import { createReduxAsyncThunk } from "shared/utils";

import dataSources from "dataSources";

import { STATE } from "../types/state";

export const getUserCurrentLocation = createReduxAsyncThunk(
  `${STATE}/getUserCurrentLocation`,
  async () => {
    return await dataSources.userLocation.geUserCurrentLocations();
  }
);
